<template>
  
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <b>
        <span>{{res.name}} - ({{res.role}})</span>
        <span v-if="!isAdmin"> : 
            <span style="color:green" v-if="green">{{ solde }}</span> : 
            <span style="color:red" v-if="!green"> {{ solde}}</span> 
              <u> {{res.type_entite}}</u> 
        </span>
      </b>
      <img
        src="img/avatars/blank-avatar.png"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
        <!-- <i class="fa fa-cog fa-2x fa-fw" style="margin: 0 10px;"></i>
        <span class="sr-only">Loading...</span> -->
    </template>\
    <template slot="dropdown">
      <!--<b-dropdown-item v-if="loggedIn"><i class="fa fa-user" /> Mon profil</b-dropdown-item>-->
      <b-dropdown-item v-if="can('soldecaisse')" @click="solde_route"><i class="fa fa-money" /> Soldes</b-dropdown-item>
      <b-dropdown-item v-if="loggedIn" @click="logout"><i class="fa fa-lock" /> Déconnexion</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import api from '../api/';
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
        isAdmin:false,
        res:{},
        itemsCount: 42,
        solde_planning :"",
        solde :"",
        green:false
      }
  },
  computed:{
    loggedIn(){
      return this.$store.getters['auth/loggedIn'];
    }
  },
  methods:{
    logout(){
      this.$router.push({name:'Logout'})
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    solde_route(){
      this.$router.push('/plannings/solde')
    },
    async get_solde(){
      this.solde_planning = await api.planning.get_solde_planning().then((data)=>{
          console.log("solde t : ",data.data.data)
          return data.data.data
      })
    },
    async get_user(){
        this.res = await store.getters['auth/get_user']
        console.log('mon solde :',this.res)
        if(isNaN(parseInt(this.res.solde))){
          this.solde=parseInt(0).toLocaleString("fr-FR", {style: "currency", currency: "XOF"})
        }else{
          this.solde = parseInt(this.res.solde).toLocaleString("fr-FR", {style: "currency", currency: "XOF"})
        }
        // vérification du solde pour l'affichage de la couleur
        if (parseInt(this.res.solde)>=0){
            this.green = true
        }else{
            this.green = false
        }
        //this.solde = new Intl.NumberFormat('fr-FR').format(this.solde);
        // this.solde = this.solde.toString()
        
        if(this.res.role.toUpperCase() =="SUPER ADMIN" || this.res.role.toUpperCase() == "CHEF AGENCE" || this.res.role.toUpperCase() =="CENTRE APPEL" ){
          this.isAdmin=true
        }
        return this.res
    },
    async get_solde1(){
      console.log(this.res.role)
      if((this.res.role.toUpperCase()=='OPERATEUR POSTE')||(this.res.role.toUpperCase()=='OPERATEUR DISTRIBUTEUR')){
        let solde = await api.atm.get_auth_guichets(localStorage.getItem('token'))
        console.log("mon solde réel : ",solde)
        this.solde = solde.data.data.solde
      }else if((this.res.role.toUpperCase()=='RESPONSABLE POSTE') || (this.res.role.toUpperCase()=='RESPONSABLE DISTRIBUTEUR' )){
        let solde = await api.entity.get_balance_entites(localStorage.getItem('token'))
        this.solde = solde.data.data.solde
      }
    }
  },
  async mounted(){
    await this.get_user()
    this.get_solde1()
    //this.get_solde()
  }
}
</script>
